import { render } from '@wordpress/element';
import './index.css';
import Tabs from './components/Tabs';
import { UserProvider } from './context/context';
import Notes from './components/Notes';

const AsiansInUs2017 = () => {
    return (
        <UserProvider>
            <div className="asian-groups-title">
                Asian groups in the U.S., 2015
            </div>
            <div className="description">
                Population estimates for the 19 largest Asian-origin groups in
                the U.S. (based on self-described race or ethnicity)
            </div>
            <div className="tabs">
                <Tabs />
            </div>

            <div className="mini-table-source" id="astrisk">
                <span id="foreign-born-note" />
            </div>
            <Notes />
            <div className="mini-table-source" id="sources">
                Source: Population estimates from U.S. Census Bureau, 2015
                American Community Survey 1-year estimates (American
                FactFinder).
            </div>
        </UserProvider>
    );
};

if (document.getElementById('js-asians-in-us-2017')) {
    render(<AsiansInUs2017 />, document.getElementById('js-asians-in-us-2017'));
}
